module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//23.jpg?21f30e1c28de81d0091cb683d8cdacc6";